<template>
	<div id="app">
		<!-- Notification components -->
		<Alerts />
		<UploadAlerts />


		<router-view />
	</div>
</template>

<script>
import '@/libs/clarks/styles/index.scss'
import '@/libs/notifications/styles/index.scss'
import '@/libs/template/styles/index.scss'
import notifications from '@/libs/notifications'

export default {
	name: "App",
	components: {
		...notifications.components
	},
	mounted(){
		utils.printAppInfo()
	}
};
</script>

<style lang="scss">
:root {
   --primary: #{$primary};
   --secondary: #{$secondary};
}

#app {
	.row{
		margin: 0;
	}
}
</style>
